import { z } from 'zod'
import { semenType } from '../semenStock/semenStockObject'
import sql from '~/prix/utils/sql'

export const semenBatchObject = z.object({
  id: z.string().uuid(),
  bullId: z.string().uuid(),
  semenType: semenType,
  unityValue: z.number(),
  supplier: z.string().nullish(),
  remainingQuantity: z.number().nullish(),
})

export const propertyMap = {
  id: sql`id`,
  bullId: sql`bull_id`,
  semenType: sql`semen_type`,
  unityValue: sql`unity_value`,
  supplier: sql`supplier`,
  remainingQuantity: sql`remaining_quantity`,
} as const
